import React from 'react';
import styled from 'styled-components';
import { FaPlus } from 'react-icons/fa';

const StyledButton = styled.button`
  width: 14rem;
  min-height: 58.39px;
  border: none;
  outline: none;
  background-color: #33c2f4;
  color: white;
  border-radius: 0.2rem;
  padding: 0;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  cursor: pointer;

  &:hover {
    background-color: #009087;
    transform: translateY(-2px);
  }
`;

const ButtonContent = styled.div`
  display: flex;
  align-items: center;
  padding: 0.5rem;
`;

const IconWrapper = styled.div`
  padding: 0.5rem;
  margin-right: 0.5rem;
  background-color: rgba(255, 255, 255, 0.25);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const TextWrapper = styled.div`
  text-align: left;
`;

const Amount = styled.p`
  font-size: 1rem;
  font-weight: bold;
  margin-bottom: 0;
  color: white;
`;

const AddCreditButton = ({text, onClick }) => {
  return (
    <StyledButton onClick={onClick}>
      <ButtonContent>
        <IconWrapper>
          <FaPlus size={20} color="white" />
        </IconWrapper>

        <TextWrapper>
          <Amount>{text}</Amount>
        </TextWrapper>
      </ButtonContent>
    </StyledButton>
  );
};

export default AddCreditButton;